import { setStore, getStore } from "assets/commonjs/storage";
import user from "./userInfo";
export const appLogin = {
  getUserInfoFromApp: () => {
    return new Promise((resolve) => {
      let userInfo = null;
      if (
        typeof window.uiObject !== "undefined" &&
        typeof window.uiObject.getInfo === "function"
      ) {
        userInfo = window.uiObject.getInfo();
      } else if (typeof window.getInfo === "function") {
        userInfo = window.getInfo();
      } else if (
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.getInfo
      ) {
        // promise func
        window.webkit.messageHandlers.getInfo.postMessage("");
        window.getInfoCallback = (info) => {
          if (
            info.account != "" &&
            info.account != undefined &&
            info.account != null
          ) {
            //已经登录
            if (typeof resolve === "function") {
              setStore("noneheader", "yes");
              resolve(info);
            }
          } else {
            setStore("userInfoAll", "");
            resolve(null);
          }
        };
        return;
      }
      if (typeof userInfo === "string") {
        resolve(JSON.parse(userInfo));
      } else {
        resolve(userInfo);
      }
    });
  },
  getAppUserInfo: function() {
    let useInfo,
      type = user.mechined();
    //如果是安卓手机浏览器且是配置的是APP内应用

    if (type == 0 && typeof window.uiObject !== "undefined") {
      useInfo = window.uiObject.getInfo(); //android终端
    } else if (type == 1) {
      //兼容旧版本
      if (typeof window.getInfo !== "undefined") {
        useInfo = window.getInfo();
      }
    } else {
      return;
    } //ios

    //如果从APP获取到的信息不为空，则到后台进行存储
    if (typeof useInfo != "undefined") {
      let userInfo = JSON.parse(useInfo);
      if (userInfo.appVerCode != "") {
        setStore("noneheader", "1");
      }
      if (userInfo.account == "") {
        setStore("userInfoAll", "");
      }
      if (
        getStore("userInfoAll") == null ||
        getStore("userInfoAll") == "" ||
        getStore("userInfoAll") == undefined
      ) {
        if (
          typeof userInfo.account != "undefined" &&
          (userInfo.account != null && userInfo.account != "")
        ) {
          //已经登录
          user.autoLogin(userInfo.account);
        }
      } else {
        let userInfoAll = JSON.parse(getStore("userInfoAll"));
        let accountInfo = userInfoAll.account;
        if (
          typeof userInfo.account != "undefined" &&
          (userInfo.account != null && userInfo.account != "") &&
          accountInfo != userInfo.account
        ) {
          //已经登录
          user.autoLogin(userInfo.account);
        }
      }
    } else {
      // setStore('userInfoAll','')
    }
  },
  getUserInfo(userInfo) {
    // 新版ios 走这里

    if (userInfo.appVerCode != "") {
      setStore("noneheader", "yes");
    }
    if (
      userInfo.account != "" &&
      userInfo.account != undefined &&
      userInfo.account != null
    ) {
      //已经登录
      user.autoLogin(userInfo.account);
    } else {
      setStore("userInfoAll", "");
    }
  },
};

export default appLogin;
